var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.8578C3.2246 11.8578 0 12.4701 0 14.9175C0 17.3667 3.2041 18.0001 7 18.0001C10.7754 18.0001 14 17.3878 14 14.9404C14 12.4912 10.7959 11.8578 7 11.8578Z",
    fill: "#7D8FB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 9.52491C9.57133 9.52491 11.6319 7.40626 11.6319 4.7625C11.6319 2.11874 9.57133 9.15527e-05 7.00004 9.15527e-05C4.42967 9.15527e-05 2.36816 2.11874 2.36816 4.7625C2.36816 7.40626 4.42967 9.52491 7.00004 9.52491Z",
    fill: "#7D8FB3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUserIcon);
export default __webpack_public_path__ + "static/media/single-user-icon.2c0aff1c93b49c4845606ca8d5ea6d3c.svg";
export { ForwardRef as ReactComponent };